var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3738_40554)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 3.875H21C21.2652 3.875 21.5196 3.98036 21.7071 4.16789C21.8946 4.35543 22 4.60978 22 4.875V20.875C22 21.1402 21.8946 21.3946 21.7071 21.5821C21.5196 21.7696 21.2652 21.875 21 21.875H3C2.73478 21.875 2.48043 21.7696 2.29289 21.5821C2.10536 21.3946 2 21.1402 2 20.875V4.875C2 4.60978 2.10536 4.35543 2.29289 4.16789C2.48043 3.98036 2.73478 3.875 3 3.875H7V1.875H9V3.875H15V1.875H17V3.875ZM15 5.875H9V7.875H7V5.875H4V9.875H20V5.875H17V7.875H15V5.875ZM20 11.875H4V19.875H20V11.875Z",
    fill: "#1C9FDA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3738_40554"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.937ddc804e010c4c155a675f581d0e9d.svg";
export { ForwardRef as ReactComponent };